/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_7_TInputs */

const en_cp_cal_7_t = /** @type {(inputs: Cp_Cal_7_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo day`)
};

const id_cp_cal_7_t = /** @type {(inputs: Cp_Cal_7_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demo day`)
};

/**
* | output |
* | --- |
* | "Demo day" |
*
* @param {Cp_Cal_7_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_7_t = /** @type {((inputs?: Cp_Cal_7_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_7_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_7_t(inputs)
	return en_cp_cal_7_t(inputs)
});